import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { crmLinks } from '../../data/crm';
import { DashboardMockup } from './DashboardMockup';
export function CrmHero() {
  return <section className="overflow-hidden bg-white px-4 pb-24 pt-16 sm:px-6 lg:px-8 lg:pb-32 lg:pt-24" data-id="element-91" data-mp="1ku3bitz883ez">
      <div className="mx-auto grid max-w-7xl items-center gap-16 lg:grid-cols-12" data-id="element-92" data-mp="1psy0kdnseo7j">
        <motion.div initial={{
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease: [0.23, 1, 0.32, 1]
      }} className="lg:col-span-6" data-id="element-93" data-mp="1b53al515yxy5">
          <p className="text-sm font-bold text-brand-red" data-id="element-94" data-mp="125y7dlenqgfn">
            1Dash.Pro — never lose another lead. We set it all up for you.
          </p>
          <h1 className="mt-5 text-4xl font-extrabold leading-[1.08] tracking-tight text-brand-black sm:text-5xl lg:text-[3.4rem]" data-id="element-95" data-mp="s6h4fbqsignd">
            Every lead captured. Every follow-up done. <span className="text-brand-red" data-id="element-96" data-mp="x7oczd0rbjv3">Every customer back for more.</span>
          </h1>
          <span className="mt-5 inline-flex items-center gap-1.5 rounded-full border border-gray-200 bg-gray-50 px-3 py-1 text-xs" data-id="element-97" data-mp="2l5qy79lxy360">
            <span className="font-bold text-brand-black" data-id="element-98" data-mp="2u805lqlwxgf6">1Dash.Pro</span>
            <span className="text-brand-gray" aria-hidden="true" data-id="element-99" data-mp="2u65sgygvusln">·</span>
            <span className="font-medium text-brand-gray" data-id="element-100" data-mp="2q76gwv0nbxl8">Powered by HighLevel</span>
          </span>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-gray-600" data-id="element-101" data-mp="22hlw06kxmq9b">
            1Dash.Pro is the one system that catches your leads, follows up for you, gets you paid, earns you reviews, and
            wins back old customers. Ad ROI builds it and runs it with you.
          </p>
          <div className="mt-9 flex flex-col gap-4 sm:flex-row" data-id="element-102" data-mp="26hw35mkgnmpr">
            <a href={crmLinks.seeItInAction} className="group inline-flex items-center justify-center gap-2 rounded-md bg-brand-red px-8 py-4 text-lg font-bold text-white shadow-lg transition-colors duration-150 ease-out hover:bg-brand-red-dark focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-103" data-mp="1isl8mmtpeok2">
              See It In Action
              <ArrowRightIcon className="h-5 w-5 transition-transform duration-150 ease-out group-hover:translate-x-0.5" aria-hidden="true" data-id="element-104" data-mp="3nlt4rqob6je6" />
            </a>
            <a href={crmLinks.talkToUs} className="inline-flex items-center justify-center rounded-md border-2 border-gray-200 bg-white px-8 py-4 text-lg font-bold text-gray-700 transition-colors duration-150 ease-out hover:border-brand-black hover:text-brand-black focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-red focus-visible:ring-offset-2" data-id="element-105" data-mp="3sn09thz2h4h5">
              Talk To Us
            </a>
          </div>
        </motion.div>

        <div className="lg:col-span-6" data-id="element-106" data-mp="k7gl8w9cca8f">
          <DashboardMockup data-id="element-107" data-mp="p3xjija984z8" />
        </div>
      </div>
    </section>;
}